<template>
  <div>
    <confirm-leave-dialog
      ref="modal_unsaved_changes"
      :text_unsaved_changes="$t('text_unsaved_changes')"
    />
    <b-row v-if="!disabled_edition" class="mt-3">
      <b-col>
        <b-button variant="secondary" class="btn btn-block" @click="cancel">
          {{ $t('cancel') }}
        </b-button>
      </b-col>
      <b-col />
      <b-col>
        <b-button
          variant="primary"
          class="btn btn-block"
          :disabled="saved"
          @click="save"
        >
          {{ $t('apply') }}
        </b-button>
      </b-col>
      <b-col>
        <b-button variant="success" class="btn btn-block" @click="validate">
          {{ $t('ok') }}
        </b-button>
      </b-col>
    </b-row>
    <b-button
      v-else
      variant="secondary"
      class="btn btn-block mt-3"
      @click="cancel"
    >
      {{ $t('back_to_workflow') }}
    </b-button>

    <save-confirmation ref="save_confirmation" />

    <div class="my-5" />
  </div>
</template>

<script>
import SaveConfirmation from './save_confirmation.vue'
import ConfirmLeaveDialog from '@/components/confirm_leave_dialog.vue'

// *****************************************************************************

export default {
  name: 'ValidationButtonsBar',
  components: {
    SaveConfirmation,
    ConfirmLeaveDialog,
  },

  props: ['saved', 'disabled_edition', 'is_validating'],
  methods: {
    show_alert() {
      this.$refs.save_confirmation.show()
    },
    check_unsaved_changes(next) {
      if (!this.saved && !this.is_validating) {
        this.$refs.modal_unsaved_changes
          .popup_and_get_answer()
          .then(confirmResult => next(confirmResult))
      } else {
        next()
      }
    },

    cancel() {
      this.$emit('cancel')
    },
    save() {
      this.$emit('save')
    },
    validate() {
      this.$emit('validate')
    },
  },
}
</script>
